import React from 'react';
import Rimg from './Rimg.jsx';
import Slider from './Slider.jsx';
import ProductContext from './ProductContext.jsx';
import SVG from './SVG.jsx';
import trackEvent from '../utils/trackEvent';
import ProductVideo from './ProductVideo.jsx';

export default class ProductMobileGallery extends React.PureComponent {
  constructor(props) {
    super();
    this.sliderRef = React.createRef();
    this.sliderNavRef = React.createRef();
    this.state = {currentIndex: 0};

    this.mobileGallerySlider = this.mobileGallerySlider.bind(this);
    this.calculatePivot = this.calculatePivot.bind(this);
    this.inversePivot = this.inversePivot.bind(this);
    this.zoomLabel = this.zoomLabel.bind(this);
  }

  inversePivot(i) {
    return (i + this.props.thumbPivot) % this.props.media.length;
  }

  calculatePivot(i) {
    return (this.props.media.length + i - this.props.thumbPivot) % this.props.media.length;
  }

  mobileGallerySlider() {
    const options = {
      prevNextButtons: false,
      pageDots: false
    };
    if (this.props.tags.includes('show-previews')) {
      return <Slider options={options} ref={this.sliderNavRef} className="mobile-product-images-slider-nav" updateKey={this.props.mediaUpdated}>
        {this.props.media.map((currentMedia, i) => {
          const currentIndex = this.calculatePivot(i);
          const media = this.props.media[currentIndex];
          let cName = 'mobile-product-image-nav wrap';
          let clickHandler = (e) => {this.sliderRef.current.flickity.select(currentIndex)};
          if (currentIndex === this.state.currentIndex) {
            cName += ' active';
          }
          let mediaIcon = null;
          if (media.media_type === 'model') {
            cName += ' model-thumb';
            mediaIcon = <span className="play-media">
              <SVG icon="3d" />
            </span>
          }
          if (media.media_type === 'video') {
            cName += ' video-thumb';
            mediaIcon = <span className="play-media">
              <SVG icon="video" />
              {media.alt && <span className="play-media-label">{media.alt}</span>}
            </span>
          }
          return <div className={cName} key={i}>
            <Rimg src={media.preview_image.src} loading="lazy" width={media.preview_image.width} height={media.preview_image.height} onClick={clickHandler} alt={media.alt || this.props.productName} sizes="18vw"  />
            {mediaIcon}
            <span className="overlay"></span>
          </div>
        })}
      </Slider>
    }
    return (null);
  }

  zoomLabel() {
    if (this.props.media.length < 1) {
      return (null);
    }
    const currentMedia = this.props.media[this.state.currentIndex]
    if (currentMedia.media_type === 'video') {
      return (null)
    }
    if (currentMedia.media_type === 'model') {
      return <span className="model-zoom-trigger">
        <SVG icon="3d" />
        <i>{this.context.i18n.viewModel}</i>
      </span>
    }
    return <span className="image-zoom-trigger">
      <SVG icon="search" />
      {this.context.i18n.mobileZoomImage && <i>{this.context.i18n.mobileZoomImage}</i>}
    </span>
  }

  render() {
    const flickityOptions = {
      wrapAround: true,
      pageDots: !this.props.tags.includes('show-previews'),
      on: {
        ready: () => {
          if (!this.props.tags.includes('show-previews')) {
            if (this.sliderRef.current) {
              const pageDots = this.sliderRef.current.querySelectorAll('.flickity-page-dots .dot');
              this.props.media.forEach((media, i) => {
                if (media.media_type === 'model') {
                  pageDots[i].setAttribute('data-model', 'true');
                } else if (media.media_type === 'video') {
                  pageDots[i].setAttribute('data-video', 'true');
                }
              })
            }
          }
        },
        select: (i) => {
          const slide = this.sliderRef.current.flickity.selectedElement;
          trackEvent('ProductImageView', { imageIndex: (i + 1), imageSrc: this.props.media[i].src, handle: this.props.handle });
        },
        change: (i) => {
          this.setState({currentIndex: i});
          if (this.sliderNavRef.current) {
            const currentIndex = this.inversePivot(i);
            this.sliderNavRef.current.flickity.select(currentIndex);
          }
        }
      }
    }

    return <div className="showcase product-images mobile-slider-enabled">
      <Slider options={flickityOptions} className="mobile-product-image-slider" ref={this.sliderRef} updateKey={this.props.mediaUpdated}>
        {this.props.media.map((media, i) => {
          if (media.media_type === 'video') {
            return <ProductVideo featured={media} key={i} className="mobile-product-image" productName={this.props.productName} handle={this.props.handle} />
          }
          if (media.media_type === 'model') {
            return <div className="mobile-product-image" key={i}>
              <Rimg src={media.preview_image.src} loading="lazy" width={media.preview_image.width} height={media.preview_image.height} onClick={(e) => {this.props._openImageZoom(media.id, e.currentTarget)}} alt={media.alt || this.props.productName} sizes="(min-width: 530px) 440px, 88vw" />
            </div>
          }
          return <div className="mobile-product-image" key={i}>
            <Rimg src={media.src} loading={i === 0 ? 'eager' : 'lazy'} fetchPriority={i === 0 ? 'high' : 'auto'} width={media.width} height={media.height} onClick={(e) => {this.props._openImageZoom(media.id, e.currentTarget)}} alt={media.alt || this.props.productName} sizes="(min-width: 530px) 440px, 88vw" />
          </div>
        })}
      </Slider>
      <this.zoomLabel />
      <this.mobileGallerySlider />
    </div>
  }
}

ProductMobileGallery.contextType = ProductContext;